import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useBudgetUnitSearchDispatch, useBudgetUnitSearchState } from './budget-unit-search-context';

export const useBudgetUnitSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useBudgetUnitSearchDispatch();
    const state = useBudgetUnitSearchState();

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-year') {
            const parsed = parseInt(value, 10);
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { year: isNaN(parsed) ? undefined : parsed } });
        } else if (name === 'input-search') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { search: value || undefined } });
        }
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { year: undefined, search: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() { navigate('/unidades-orcamentarias/cadastrar'); }
    function navigateToEdit(id: number) { navigate(`/unidades-orcamentarias/editar/${id}`); }

    return { handleOnChange, handleSearch, handleClearFilters, navigateToCreate, navigateToEdit };
};
